export default __webpack_public_path__ + "static/media/ray7.ae43561a.webp";